import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FirebaseService } from 'src/app/services/firebase.service';
import { EliminarCotizacionPersonaNaturalComponent } from './eliminar-cotizacion-persona-natural/eliminar-cotizacion-persona-natural.component';

@Component({
  selector: 'app-cotizaciones-persona-natural',
  templateUrl: './cotizaciones-persona-natural.component.html',
  styleUrls: ['./cotizaciones-persona-natural.component.scss']
})
export class CotizacionesPersonaNaturalComponent implements AfterViewInit {

  count: number;
  loading: boolean;
  whatsApp: string;
  value;

  displayedColumns = [ 'datos.fechaCreacion', 'id', 'datos.nombre', 'datos.apellidos', 'datos.email', 'datos.celular', 'plan.tipoPlan.nombre', 'plan.tipoPlan.precio', 'plan.tipoVehiculo', 'plan.cantidad', 'cotizacion', 'mas'];
  cotizacionesEmpresaData = new MatTableDataSource();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.cotizacionesEmpresaData.filter = filterValue;
  }

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.cotizacionesEmpresaData.filter = filterValue.trim().toLowerCase();
  // }

  constructor(
    private fs: FirebaseService,
    private dialog: MatDialog
  ) { }

  ngAfterViewInit(): void {
    this.fs.getAllCotizacionesPersonaNatural().subscribe(data => {
      this.cotizacionesEmpresaData.data = data;
      this.loading = false;
      this.count = data.length;
    });
    this.cotizacionesEmpresaData.paginator = this.paginator;
    this.cotizacionesEmpresaData.sort = this.sort;

    // Para ordenar objetos anidados
    this.cotizacionesEmpresaData.sortingDataAccessor = (item, property) => {
      // Split '.' to allow accessing property of nested object
      if (property.includes('.')) {
          const accessor = property.split('.');
          let value: any = item;
          accessor.forEach((a) => {
              value = value[a];
          });
          return value;
      }
      // Access as normal
      return item[property];
    };

    // Para filtrar objetos anidados, incluye minusculas
    this.cotizacionesEmpresaData.filterPredicate = (data: any, filter: string) => {
      const dataStr = JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) !== -1;
    };

  }

  clearFilters() {
    this.cotizacionesEmpresaData.filter = '';
    this.value = '';
  }

  openModalDelete(producto) {
    const dialogRef = this.dialog.open(EliminarCotizacionPersonaNaturalComponent, {
      width: '340px',
      data: producto
    });
    dialogRef.afterClosed().subscribe();
  }

}
